import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRedirectQrData } from "../../redux/event";
import { useParams } from "react-router-dom";
import Loader from "../loader";

export const RedirectQr = () => {
	const dispatch: any = useDispatch();
	const params = useParams();
	const event: any = useSelector((state: any) => state.event);

	useEffect(() => {
		(async () => {
			const res = await dispatch(getRedirectQrData({ qrId: params?.qrId }));
			if (res?.payload?.data?.url && !!res?.payload?.data?.isActive) {
				window.location.href = res?.payload?.data?.url;
			} else {
				window.location.href = "https://www.esstart.com/";
			}
		})();
	}, []);

	return <div>{event.loading && <Loader />}</div>;
};
